import Full from "./solar-full.svg";
import Partial from "./solar-partial.svg";
import Uncertain from "./solar-uncertain.svg";

const icons = {
  "solar-full": Full,
  "solar-partial": Partial,
  "solar-uncertain": Uncertain,
};

export default icons;
